import { Card, CardBody, CardHeader, CardHeading } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { DetailsPageInfoField } from "../../../../shared/ui/DetailsPageInfoField";
import { EventDetailResource } from "../../shared/types";

const StyledCardBody = styled(CardBody)`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: ${({ theme }) => theme.spacing(5)};
`;

interface Props {
	event: EventDetailResource;
}

export const EventKeyMetricsCard: FC<Props> = ({ event }) => {
	const { t } = useTranslation();

	const shouldRenderKeyMetricsCard =
		event.eventType.visitorsMetricRequirement !== "prohibited" ||
		event.eventType.invitedPersonsMetricRequirement !== "prohibited" ||
		event.eventType.registrationsMetricRequirement !== "prohibited" ||
		event.eventType.customersMetricRequirement !== "prohibited" ||
		event.eventType.employeesMetricRequirement !== "prohibited" ||
		event.eventType.eventReachMetricRequirement !== "prohibited" ||
		event.eventType.eventGoalRatingMetricRequirement !== "prohibited";

	if (!shouldRenderKeyMetricsCard) {
		return null;
	}

	return (
		<Card>
			<CardHeader>
				<CardHeading>{t("Key Metrics")}</CardHeading>
			</CardHeader>
			<StyledCardBody>
				{event.eventType.visitorsMetricRequirement !== "prohibited" && (
					<DetailsPageInfoField title={t("Total number of event visitors")} value={event.visitorsMetric || "-"} />
				)}
				{event.eventType.invitedPersonsMetricRequirement !== "prohibited" && (
					<DetailsPageInfoField title={t("Invited persons")} value={event.invitedPersonsMetric || "-"} />
				)}
				{event.eventType.registrationsMetricRequirement !== "prohibited" && (
					<DetailsPageInfoField title={t("Registrations")} value={event.registrationsMetric || "-"} />
				)}
				{event.eventType.customersMetricRequirement !== "prohibited" && (
					<DetailsPageInfoField title={t("Customers on site")} value={event.customersMetric || "-"} />
				)}
				{event.eventType.employeesMetricRequirement !== "prohibited" && (
					<DetailsPageInfoField title={t("Employees on site")} value={event.employeesMetric || "-"} />
				)}
				{event.eventType.eventReachMetricRequirement !== "prohibited" && (
					<DetailsPageInfoField title={t("Event reach")} value={event.eventReachMetric || "-"} />
				)}
				{event.eventType.eventGoalRatingMetricRequirement !== "prohibited" && (
					<DetailsPageInfoField
						title={t("Has the event goal been achieved?")}
						value={event.eventGoalRatingMetric ? `${event.eventGoalRatingMetric} / 10` : "-"}
					/>
				)}
			</StyledCardBody>
		</Card>
	);
};
